import {Subject, Observable} from 'rxjs';
import {map, share} from 'rxjs/operators';
import {AbstractRoleProvider} from './role-provider';
import {Injectable} from '@angular/core';

export interface RoleUpdateEvent {
  source: AbstractRoleUpdateAwareProvider;
  data: any;
}

@Injectable()
export abstract class AbstractRoleUpdateAwareProvider extends AbstractRoleProvider {
  protected rolesUpdateDataSubject = new Subject<RoleUpdateEvent>();
  public roleUpdates$: Observable<RoleUpdateEvent> = this.rolesUpdateDataSubject.asObservable().pipe(
    map(data => ({source: this, data})),
    share()
  );
}
